import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/employees',
    name: 'EmployeesView',
    meta: {
      moduleId: 'employeesOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    component: () => import(/* webpackChunkName: "employees-view" */ '../modules/employees/components/EmployeesView'),
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/employees/:id',
    name: 'EmployeeForm',
    component: () => import(/* webpackChunkName: "employees-form" */ '@/modules/employees/components/EmployeeForm'),
    meta: {
      moduleId: 'employeesOverview',
      registries: ['configurations/employees'],
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/groups',
    name: 'GroupsView',
    component: () => import(/* webpackChunkName: "groups-view" */ '../modules/organisation/groups/components/GroupsView'),
    meta: {
      moduleId: 'groupOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/groups/:id',
    name: 'GroupForm',
    component: () => import(/* webpackChunkName: "groups-form" */ '../modules/organisation/groups/components/GroupForm'),
    meta: { moduleId: 'groupOverview' },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/departments',
    name: 'DepartmentsView',
    component: () => import(/* webpackChunkName: "departmens-view" */ '../modules/organisation/departments/components/DepartmentsView'),
    meta: {
      moduleId: 'departmentOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/departments/:id',
    name: 'DepartmentsForm',
    component: () => import(/* webpackChunkName: "departmens-form" */ '../modules/organisation/departments/components/DepartmentsForm'),
    meta: { moduleId: 'departmentOverview' },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/roles',
    name: 'RolesView',
    component: () => import(/* webpackChunkName: "roles-view" */ '@/modules/roles/components/RolesView'),
    meta: {
      moduleId: 'roleOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/roles/:id',
    name: 'RoleForm',
    component: () => import(/* webpackChunkName: "roles-form" */ '@/modules/roles/components/RoleForm'),
    meta: { moduleId: 'roleOverview' },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/deputytypes',
    name: 'DeputyTypesView',
    component: () => import(/* webpackChunkName: "deputytypes-view" */ '@/modules/deputy_types/components/DeputyTypesView'),
    meta: {
      moduleId: 'deputytypes',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/deputytypes/:id',
    name: 'DeputyTypeForm',
    component: () => import(/* webpackChunkName: "deputytypes-form" */ '@/modules/deputy_types/components/DeputyTypeForm'),
    meta: {
      moduleId: 'deputytypes',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/ldapsynchronization',
    name: 'LDAPSynchronizationView',
    component: () => import(/* webpackChunkName: "ldapsynchronization-view" */ '../../src/modules/ldap_synchronization/components/LDAPSynchronizationView'),
    meta: {
      moduleId: 'ldapsynchronization'
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/overtimetrims',
    name: 'OvertimeTrimView',
    component: () => import(/* webpackChunkName: "overtimetrim-view" */ '@/modules/overtime_trims/components/OvertimeTrimView'),
    meta: {
        moduleId: 'overtimeTrimOverview',
        decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/overtimetrims/:id',
    name: 'OvertimeTrimForm',
    component: () => import(/* webpackChunkName: "overtimetrim-form" */ '@/modules/overtime_trims/components/OvertimeTrimForm'),
    meta: {
        moduleId: 'overtimeTrimOverview',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/companylocations',
    name: 'CompanyLocationsView',
    component: () => import(/* webpackChunkName: "companylocations-view" */ '@/modules/company_locations/components/CompanyLocationsView'),
    meta: {
      moduleId: 'companylocations',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/companylocations/:id',
    name: 'CompanyLocationsForm',
    component: () => import(/* webpackChunkName: "companylocations-form" */ '@/modules/company_locations/components/CompanyLocationsForm'),
    meta: {
      moduleId: 'companylocations',
      preloads: [
        'contacts/addresstypes',
        'system/countries/default',
      ]
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/skillmatrix',
    name: 'SkillMatrixView',
    component: () => import(/* webpackChunkName: "skill-matrix" */ '@/modules/skill_matrix/components/SkillMatrixView'),
    meta: {
      moduleId: 'skillmatrix',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/curriculumvitae',
    name: 'CurriculumVitaeView',
    component: () => import(/* webpackChunkName: "curriculumvitae-view" */ '@/modules/curriculum_vitae/components/CurriculumVitaeView'),
    meta: {
      moduleId: 'curriculumVitae',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/cvreport',
    name: 'CVReportView',
    component: () => import(/* webpackChunkName: "cv-report-view" */ '../../src/modules/curriculum_vitae/components/CVReportView'),
    meta: {
      moduleId: 'cvReport',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/curriculumvitae/:id',
    name: 'CurriculumVitaeForm',
    component: () => import(/* webpackChunkName: "curriculumvitae-form" */ '@/modules/curriculum_vitae/components/CurriculumVitaeForm'),
    meta: {
      moduleId: 'curriculumVitae',
    },
		props: true,
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/skillcategories',
    name: 'SkillCategoriesView',
    component: () => import(/* webpackChunkName: "skillcategories-view" */ '@/modules/skill_categories/components/SkillCategoriesView'),
    meta: {
      moduleId: 'skillCategories',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/skillcategories/:id',
    name: 'SkillCategoryForm',
    component: () => import(/* webpackChunkName: "skillcategory-form" */ '@/modules/skill_categories/components/SkillCategoryForm'),
    meta: {
      moduleId: 'skillCategories',
    },
    props: true,
    beforeEnter: checkAuthenticated,
  },
];
